/**
 * @Author: Kerem Koç <keremkoc>
 * @Date:   2018-02-28T06:28:38+03:00
 * @Email:  kerem@kocapps.com
 * @Filename: collapsible.text.js
 * @Last modified by:   keremkoc
 * @Last modified time: 2018-02-28T06:41:48+03:00
 */
(function($, root) {

  $('.collapsible-text .short .readmore').click(function() {

    var main_object = $(this).parents('.collapsible-text');

    main_object.find('.short').hide();
    main_object.find('.whole').fadeIn();

  });

  $('.collapsible-text .whole .readless').click(function() {

    var main_object = $(this).parents('.collapsible-text');

    main_object.find('.whole').hide();
    main_object.find('.short').fadeIn();

  });
})(jQuery, this);
